import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'

import { FeatureFlagKeys } from '@hapana/shared/constants/feature-flag.constants'
import { useFeatureFlag } from '_hooks/useFeatureFlag'

import { ROUTES } from '../../../app.constants'

interface BrandTaxSettingsRouteGuardProps {
  children: ReactElement
}

// OC-1277: the Control Centre card is filtered by the same flag; without the route guard the
// screen would stay reachable by direct link after the flag is switched off for a brand.
const BrandTaxSettingsRouteGuard = ({ children }: BrandTaxSettingsRouteGuardProps) => {
  const { value: isEnabled, isLoading } = useFeatureFlag(
    FeatureFlagKeys.BrandControlsTaxSettingsEnabled,
    { defaultValue: false }
  )
  if (isLoading) {
    return null
  }
  if (!isEnabled) {
    return <Navigate to={`/c/${ROUTES.controlCenter.path}`} replace />
  }
  return children
}

export default BrandTaxSettingsRouteGuard
